module.exports = __webpack_public_path__ + "basic7.png?5a1573b3552f18ae196a3d239d53f04f";